<template>
	<div>
		<div class="text-center list-title">
			Реестр результатов оценки актов ЛПО
		</div>
		<div class="l-header-wrapper">
			<table class='header'>
				<thead>
					<tr>
						<th class='center l-td'>№ акта ЛПО</th>
						<th class='center l-td'>Дата размещения</th>
						<th class='center l-td'>ФО</th>
						<th class='center l-td'>Субъект РФ</th>
						<th class='center l-td'>Лесничество</th>
						<th class='center l-td'>Итоговое решение ФБУ "Рослесозащита"</th>
						<th class='center l-td'>Главная причина отрицательного заключения</th>
						<th class='center l-td'>Итоговое решение "Документарная проверка"</th>
						<th class='center l-td'>Нарушение пунктов Постановления прав-ва 1158</th>
						<th class="l-scroll"></th>
					</tr>
					<tr>
						<th class='l-td'><filter-table field='act_num' :filter='filter' :suffix='journalSuffix'/></th> 
						<th class='l-td'><filter-table-date-range field='act_placement_date' :filter='filter' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='fo' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='region' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='forestry' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='conclusion_decision' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='conclusion_decision_reason' :filter='filter' :wideWindow='true' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='warrant_decision' :filter='filter' :suffix='journalSuffix'/></th>
						<th class='l-td'><filter-table field='violation' :filter='filter' :suffix='journalSuffix'/></th>
						<th class="l-scroll" @click='clearFilters'><span class="glyphicon glyphicon-remove pointer" title="Сбросить фильтры"></span></th>
					</tr>
				</thead>
			</table>
		</div>
		<div class="l-body-wrapper">
			<table class='body'>
				<tbody>
					<tr v-for='(line,i) in lines' @click='select_line(i)' :key="line.act_id" :class='{ selected: line.selected }'>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.act_num}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.act_placement_date}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.fo}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.region}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.forestry}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.conclusion_decision}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.conclusion_decision_reason}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.warrant_decision}}</td>
					<td v-if='line.flag' :rowspan='line.count' class='td-num l-td'>{{line.violation}}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div>
		<div class='pull-left' style='position: absolute; margin: 20px;' v-if='lines.length'>
			<a class="btn btn-primary" :href='DBlink + "get_journal_decisions_csv.php"'>Выгрузить</a>
		</div>
		<div class="text-center">
			<ul class="pagination" v-if='pages'>
				<li :class='{ active: page.active }' v-for='page in pages' :key="page.num">
					<a v-if='isNumeric(page.num)' href='#' @click='select_page' :data-value='page.num'>{{page.num}}</a>
					<span v-else href='#' class="disabled_page">{{page.num}}</span>
				</li>
			</ul>
		</div>
	</div>

	<alert :value.sync="displayAlert" placement="top" type="warning" width="400px" duration="0" dismissable>
	  <i class="fa fa-info-circle" aria-hidden="true"></i>
	  <strong>Внимание!</strong>
	  <p style='font-size:15px;'>Началось формирование документа. Пожалуйста, не закрывайте страницу.</p>
	</alert>

</div>
</template>

<script>
	import {DB} from './../constants'
	import {ROWS_ON_PAGE} from './../constants'
	import './../lib/css/fontawesome-all.min.css'
	const TABLE = 'get_journal_decisions.php'
	const FILTER_TABLE = 'get_journal_decisions.php'
	const COUNT_OF_FILTERS = 9
	const PADDING = 3

	import { EventBus } from '../lib/EventBus'

	import filterTable from './Filter'
	import filterTableDateRange from './FilterDateRange'
	import moment from 'moment'
	import { alert } from 'vue-strap'

	export default {
		name: 'ListDecisions',
		data () {
			return {
				lines: [],
				selected: 0,
				pages: [],
				active: 1,
				pages_count: 1,
				cf_count: 0,
				displayAlert: false,
				alwaysFalse: false,

				filter: {
					act_num: [],
					act_placement_date: [],
					conclusion_decision: [],
					fo: [],
					region: [],
					forestry: [],
					conclusion_decision_reason: [],
					warrant_decision: [],
					violation: []
				},

				DBlink: DB,
				journalSuffix: '-decisions'
			}
		},
		components: {
			filterTable, alert, filterTableDateRange
		},
		methods: {
			isNumeric (x) {
				return !Number.isNaN(+x)
			},
			select_line (i) {
				if (!this.lines[i].flag) {
					let k = i
					while (!this.lines[k].flag) {
						k--
					}

					i = k
				}

				this.selected = i

				for (let j = 0; j < this.lines.length; j++) {
					if (this.lines[j].flag) {
						this.lines[j].selected = (i === j)
					}
					else {
						let k = j
						while (!this.lines[k].flag) {
							k--
						}
						for (let l = 0; l < this.lines[k].count; l++) {
							this.lines[j].selected = (i === k)
						}
					}
				}

				EventBus.$emit('act_id', this.lines[i].id)

				// document.getElementById(i).checked = true
				//EventBus.$emit('can_edit', {act: this.lines[i].can_edit_act, conclusion: this.lines[i].can_edit_conclusion, warrant: this.lines[i].can_edit_warrant})
			},
			fetch_lines (start) {
				let temp_lines = []
				let temp_pages = []

				let where = '('
				for (let f in this.filter) {
					let field_name = f
					field_name = field_name.replace(this.journalSuffix, '') 

					if(field_name == 'act_placement_date') {
						if(this.filter[f].length == 2) {
							const from = this.filter[f][0]
							const to = this.filter[f][1]
							where += `${field_name} BETWEEN '${from}' AND '${to}'  or `
						}
					} else {
						for (let i = 0; i < this.filter[f].length; i++) {
							where += this.filter[f][i] !== '' ? `${field_name}='${this.filter[f][i]}' or ` : `${field_name} is null or `	
						}
					}
					
					
					where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
					where += this.filter[f].length !== 0 ? ') and (' : ''
				}

				where = where.slice(0,-6)
				if(where)
					where = '&filter=' + where

				fetch(DB + FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}${where}`, {
					// fetch(DB + TABLE, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						let prev_id = -1
						let prev_localforestry_id = -1
						let prev_subforestry_id = -1
						for (let i = 0; i < res.length - 1; i++) {
							let act = {}

							let start_fo = i
							while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
								start_fo--
							}

							let curr = start_fo
							while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
								curr++
							}
							act.count = curr - start_fo

							if (res[i].act_id === prev_id) {
								act.flag = false
							}
							else {
								act.flag = true
							}
							//////////////////

							let start_lf = i
							while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
								start_lf--
							}

							let curr_lf = start_lf
							while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
								curr_lf++
							}
							act.count_lf = curr_lf - start_lf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_lf = false
							}
							else {
								act.flag_lf = true
							}

							////////////////////////
							let start_sf = i
							while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
								start_sf--
							}

							let curr_sf = start_sf
							while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
								curr_sf++
							}
							act.count_sf = curr_sf - start_sf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_sf = false
							}
							else {
								act.flag_sf = true
							}
							////////////////////////
							

							prev_id = res[i].act_id
							prev_localforestry_id = res[i].localforestry_id
							prev_subforestry_id = res[i].subforestry_id

							act.id = res[i].act_id
							act.act_num = res[i].act_num
							act.act_placement_date = res[i].act_placement_date
							act.conclusion_decision = res[i].conclusion_decision
							act.conclusion_decision_reason = res[i].conclusion_decision_reason
							act.warrant_decision = res[i].warrant_decision
							act.violation = res[i].violation
							act.fo = res[i].fo
							act.region = res[i].region
							act.forestry = res[i].forestry
							act.selected = false

							temp_lines.push(act)
						}


						this.lines = temp_lines

						temp_lines = []

						// this.pages = temp_pages

						this.lines[0].selected = true

						if (!this.lines[1].flag) {
							let k = 1
							while (!this.lines[k].flag) {
								this.lines[k].selected = true
								k++
							}
						}

						EventBus.$emit('act_id', this.lines[0].id)
					})
					.catch(err => console.log(err))
				},
				select_page (e) {
					let value = +e.target.getAttribute('data-value')
					this.fetch_lines((value - 1) * ROWS_ON_PAGE + 1)
					this.active = value
					let temp_pages = []

					if(this.active - 1 > PADDING)
					{
						temp_pages.push({active: false, num: 1})
						temp_pages.push({active: false, num: '...'})
					}

					for (let i = this.active - PADDING - 1; i < this.active + PADDING; i++)
						if(i >= 0 && i < this.pages_count)
							temp_pages.push({active: false, num: i + 1})

					if(this.active < this.pages_count - PADDING)
					{
						temp_pages.push({active: false, num: '...'})
						temp_pages.push({active: false, num: this.pages_count})
					}

					this.pages = temp_pages

					this.pages.forEach(p => {
						p.active = (p.num == this.active)
					})

					//this.pages[value - 1].active = true
				},
				clearFilters () {
					this.cf_count = 0
					EventBus.$emit('clearFilters' + this.journalSuffix)
				},
				filter_lines () {
					let temp_lines = []
					let temp_pages = []

					let where = '('
					for (let f in this.filter) {
						let field_name = f
						field_name = field_name.replace(this.journalSuffix, '') 
						if(field_name == 'act_placement_date') {
							if(this.filter[f].length == 2) {
								const from = this.filter[f][0]
								const to = this.filter[f][1]
								where += `${field_name} BETWEEN '${from}' AND '${to}'  or `
							}
						} else {
							for (let i = 0; i < this.filter[f].length; i++) {
								where += this.filter[f][i] !== '' ? `${field_name}='${this.filter[f][i]}' or ` : `${field_name} is null or `
							}
						}
						
						where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
						where += this.filter[f].length !== 0 ? ') and (' : ''
					}
					where = where.slice(0,-6)

					let start = 1

					if (this.$route.params.id  || this.$parent.act_id) {
						start = (this.page_num - 1) * ROWS_ON_PAGE + 1
						this.active = this.page_num
					}

					let t = TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}`
					if (where) {
						t = FILTER_TABLE + `?start=${start}&rows=${ROWS_ON_PAGE}&filter=${where}`
					}

					fetch(DB + t, {
						credentials: 'include'
					})
					.then(res => res.json())
					.then(res =>{
						let prev_id = -1
						let prev_localforestry_id = -1
						let prev_subforestry_id = -1

						let length = (!!where) ? res.length : res.length - 1

						for (let i = 0; i < length; i++) {
							let act = {}

							let start_fo = i
							while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
								start_fo--
							}

							let curr = start_fo
							while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
								curr++
							}
							act.count = curr - start_fo

							if (res[i].act_id === prev_id) {
								act.flag = false
							}
							else {
								act.flag = true
							}
							//////////////////

							let start_lf = i
							while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
								start_lf--
							}

							let curr_lf = start_lf
							while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
								curr_lf++
							}
							act.count_lf = curr_lf - start_lf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_lf = false
							}
							else {
								act.flag_lf = true
							}

							////////////////////////
							let start_sf = i
							while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
								start_sf--
							}

							let curr_sf = start_sf
							while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
								curr_sf++
							}
							act.count_sf = curr_sf - start_sf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_sf = false
							}
							else {
								act.flag_sf = true
							}
							////////////////////////
							

							prev_id = res[i].act_id
							prev_localforestry_id = res[i].localforestry_id
							prev_subforestry_id = res[i].subforestry_id

							act.id = res[i].act_id
							act.act_num = res[i].act_num
							act.act_placement_date = res[i].act_placement_date
							act.conclusion_decision = res[i].conclusion_decision
							act.conclusion_decision_reason = res[i].conclusion_decision_reason
							act.warrant_decision = res[i].warrant_decision
							act.violation = res[i].violation
							act.fo = res[i].fo
							act.region = res[i].region
							act.forestry = res[i].forestry
							act.selected = false
							
							temp_lines.push(act)
						}

						//if (!where) {
							//let count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
							this.pages_count = Math.round(res[res.length - 1].count / ROWS_ON_PAGE)
							temp_pages = []

							if(this.active > PADDING)
							{
								temp_pages.push({active: false, num: 1})
								temp_pages.push({active: false, num: '...'})
							}

							
							for (let i = this.active - PADDING; i < this.active + PADDING; i++) {
								if(i >= 0 && i < this.pages_count)
									temp_pages.push({active: false, num: i + 1})
							}

							if(this.active < this.pages_count - PADDING)
							{
								temp_pages.push({active: false, num: '...'})
								temp_pages.push({active: false, num: this.pages_count})
							}

							this.pages = temp_pages
							this.pages.forEach(p => {
								p.active = (p.num == this.active)
							})
						//}

						this.lines = temp_lines

						if(this.$route.params.id || this.$parent.act_id) {
							let act_id = this.$route.params.id || this.$parent.act_id
							let found = false
							for (let i = 0; i < this.lines.length; i++) {
								if (this.lines[i].id == act_id) {
									this.select_line(i)

									this.$nextTick(() => {
										const selected_row = document.querySelector("tr.selected")
										if(selected_row)
											selected_row.scrollIntoView(true)
									})

									found = true
									break
								}
							}
							if(!found)
								this.select_line(0)
						}
						else {
							this.select_line(0)
						}
						
					})
					.catch(err => console.log(err))
				}

			},
			created () {

			},
			mounted () {
				this.$parent.lastJournalURL = '/main/decisions'

				EventBus.$on('filter' + this.journalSuffix + '_list', f => {
					this.filter[f.field + this.journalSuffix] = f.value !== '' ? f.value : null
					this.active = 1
					if(f.cf) //clearFilters
					{
						this.cf_count++
						if(this.cf_count == COUNT_OF_FILTERS)
							this.filter_lines()
					}
					else
						this.filter_lines()
				})

				this.page_num = this.$parent.page_num_decisions ? this.$parent.page_num_decisions : 1

				//console.warn(this.$parent.selected_filters, this.$parent.selected_filters.length)

				if(this.$parent.selected_filters) {
					for(let field in this.$parent.selected_filters) {
						if(field.includes(this.journalSuffix))
							this.filter[field] = this.$parent.selected_filters[field].value
					}
				}
				
				this.filter_lines()

				// const w = document.documentElement.clientWidth - 50
				// document.querySelector('.main_table_wrapper').style.width = `${w}px`

				////////////////////////////////////////////

				const dispay_width = document.documentElement.clientWidth
				// const dispay_height = document.documentElement.clientHeight - 146
				const dispay_height = document.documentElement.clientHeight - 225
				let scroll_width = 17

				const ua = navigator.userAgent

				if (ua.search('OPR/') > 0) {
					scroll_width = 15
				}

				const table_width = dispay_width - scroll_width
				const col_width = Math.floor(table_width / COUNT_OF_FILTERS)
				// 
				const large_width = table_width - (col_width * 9)

				// console.log(col_width, large_width, table_width, col_width * 9 + large_width)


				document.querySelectorAll('.l-td').forEach(td => {
					td.width = col_width
				})
				document.querySelectorAll('.large-td').forEach(td => {
					td.width = large_width
				})
				document.querySelector('.l-header-wrapper').width = dispay_width
				document.querySelector('.l-body-wrapper').width = dispay_width
				document.querySelector('.l-body-wrapper').style.maxHeight = `${dispay_height}px`

			// console.log(dispay_height, dispay_width, col_width, table_width)
			// console.log(ua, ua.search('Chrome/'), ua.search('Firefox/'), ua.search('OPR/'))

				document.querySelector('.l-scroll').width = scroll_width
			},
			beforeDestroy() {
				//this.lines = []
				EventBus.$off('filter' + this.journalSuffix + '_list')
				EventBus.$emit('save-page' + this.journalSuffix, this.active)
			}
		}

		</script>

		<style>

		div.l-header-wrapper {
			border: 1px solid black;
			border-bottom: none;  
			/*width: 1634px;*/
		}

		div.l-body-wrapper {
			overflow-x: hidden;
			overflow-y: scroll;
			/*width: 1634px;*/
			/*max-height: 1200px;*/
			border: 1px solid black;
			border-top: none;
		}

		table.header {
			border-bottom: 1px solid black;
			width: 100%;
		}

		td.l-td,  th.l-td {
			vertical-align: middle; 
			word-break: break-all; 
			font-size: 12px;
		}

		td.large-td,  th.large-td {
			/*width: 214px;*/
			vertical-align: middle;  
		}

		table.body {
			width: 100%;
			table-layout: fixed;
		}

		.main_table tr, td, .main_table tr, th {
			text-align: center !important;
			border: 1px solid;
			border-collapse: collapse;
		}

		.td-url {
			word-break: break-all;
		}

		.td-num {
			max-width: 170px;
		}

		.main_table tr {
			height: 21px;
		}


	/* .radio_input {
		margin: 5px !important;
		} */

		th.center {
			text-align: center !important;
		}

		.selected {
			background-color: skyblue;
		}

		.disabled_page {
			cursor: default;
		}
		</style>

		<style scoped>
			.pagination {
				margin: 20px 0 4px 0;
			}

			td.l-td,  th.l-td {
				word-break: break-word !important; 
			}

			.save-to-csv-button {
				margin-top: 20px;
				position: absolute;
			}
		</style>


// WEBPACK FOOTER //
// ListDecisions.vue?6b941dd0